import React from 'react';
import PropTypes from 'prop-types';

import Icon from './icon';

const ButtonFilter = ({
	label,
	classes = '',
	isActive,
	onClick,
}) => (
	<button
		className={`filter-button ${isActive && 'is-active'} ${classes}`}
		onClick={onClick}
		type="button"
	>
		<div className="flex-row justify-space-between align-items-center">
			<div className="filter-button__label">{label}</div>
			<Icon icon="xmark" />
		</div>
	</button>
);

export default ButtonFilter;

ButtonFilter.propTypes = {
	label: PropTypes.string.isRequired,
	classes: PropTypes.string,
	isActive: PropTypes.bool.isRequired,
	onClick: PropTypes.func.isRequired,
};
